<template>
    <div class="patient-details d-flex">
        <div class="profile-status">
            <p class="fw-bold" v-if="getBranchName">{{ getBranchName.name }}</p>
            <div class="pic">
                <span
                    v-if="selectedPatientDetails.photo"
                    class="uploaded-pic"
                    ref="userPicElement"
                    :style="{ backgroundImage: `url(${selectedPatientDetails.photo.PhotoUrl})` }"
                ></span>
                <i v-else class="no-pic fas fa-user"></i>
            </div>
            <p class="fw-bold">
                {{
                    selectedPatientDetails.status === 0
                        ? "None"
                        : String(statusEnum.getDescriptionUsingValue(selectedPatientDetails.status)).toLocaleUpperCase()
                }}
            </p>
        </div>
        <HosPalPatientMain
            :application="application"
            :agencyId="agencyId"
            :selectedPatientDetails="selectedPatientDetails"
        />
    </div>
</template>

<script src="./HosPalProfileDetails.ts"></script>
